/**
 * Formats the value for the Quill editor to support text from the API including AI generated content.
 * The new Quill editor uses <ol> for bullet lists: https://github.com/slab/quill/issues/3957
 */
export function formatForQuillEditor(value?: string): string {
  if (!value) return ''

  return value
    .replace(/<ul>([\s\S]*?)<\/ul>/gi, (match) =>
      match.replace(/<li>/gi, '<li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>'),
    )
    .replace(/<ol>([\s\S]*?)<\/ol>/gi, (match) =>
      match.replace(/<li>/gi, '<li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>'),
    )
    .replace(/<ul>/g, '<ol>')
    .replace(/<\/ul>/g, '</ol>')
    .replace(/<\/p>\n<p>/g, '</p><p>') // fix for new lines in between paragraphs
    .replace(/\n\s*/g, ' ') // remove new lines and any trailing whitespace
    .replace(/<b>/g, '<strong>')
    .replace(/<\/b>/g, '</strong>') // replace <b> with <strong>
}
